import { EVENT_CONFIG_INITIAL_STATE } from '../../../common/constants/integrationConstants/eventConfigConstants';
import getEventConfigIntervalKeyName from '../../../common/util/eventConfigUtils';
import { clearUnsavedChanges } from '../../routines/integrations/crmRoutines';
import {
  fetchEventConfigInterval,
  saveEventConfigInterval,
  changeEventConfigInterval,
  cancelEventConfigInterval,
} from '../../routines/integrations/eventConfigRoutines';

const initialState = EVENT_CONFIG_INITIAL_STATE;

const eventConfigReducer = (state = initialState, action) => {
  switch (action.type) {
    case saveEventConfigInterval.TRIGGER:
      return {
        ...state,
      };
    case saveEventConfigInterval.SUCCESS: {
      const { consumer, level, interval } = action.payload;

      const key = getEventConfigIntervalKeyName(consumer, level);
      const newState = {
        ...state,
        [key]: interval,
      };
      return {
        ...state,
        ...newState,
        loading: false,
        error: null,
        hasUnSavedChange: false,
        persistedState: newState,
      };
    }
    case fetchEventConfigInterval.TRIGGER:
      return {
        ...state,
        loading: true,
        error: null,
      };
    case fetchEventConfigInterval.SUCCESS: {
      const eventConfigs = action.payload;
      const newState = eventConfigs.reduce(
        (stateObj, item) => {
          const { consumer, interval, level } = item;
          const key = getEventConfigIntervalKeyName(consumer, level);
          return {
            ...stateObj,
            [key]: interval,
          };
        },
        { ...state }
      );

      return {
        ...state,
        ...newState,
        persistedState: newState,
        loading: false,
        error: null,
        hasUnSavedChange: false,
      };
    }
    case fetchEventConfigInterval.FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload.error,
      };

    case changeEventConfigInterval.TRIGGER: {
      const { consumer, level, interval } = action.payload;
      const intervalKey = getEventConfigIntervalKeyName(consumer, level);
      return {
        ...state,
        [intervalKey]: interval,
        hasUnSavedChange: true,
      };
    }

    case cancelEventConfigInterval.TRIGGER: {
      const { consumer, level } = action.payload;
      const intervalKey = getEventConfigIntervalKeyName(consumer, level);
      return {
        ...state,
        [intervalKey]: state.persistedState[intervalKey],
        hasUnSavedChange: false,
      };
    }

    case clearUnsavedChanges.TRIGGER: {
      const { hasUnSavedChange } = { ...state };

      if (hasUnSavedChange) {
        const { vendor, entityTab } = action.payload;
        const intervalKey = getEventConfigIntervalKeyName(vendor, entityTab);
        return {
          ...state,
          [intervalKey]: state.persistedState[intervalKey],
          hasUnSavedChange: false,
        };
      }
      return {
        ...state,
      };
    }
    default:
      return state;
  }
};
export default eventConfigReducer;
